import React, { useEffect, useMemo } from 'react';
import { Bottom, ButtonDiv, Header, Text, Top } from './styles';
import Button from '../../button';
import { useMediaRecorder } from '../../../hooks/useMediaRecorder';
import { isEmpty } from '../../../helpers/common';
import { Dropdown, DropdownItem } from '../../dropdown';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { rootStore } from '../../../mobx/rootStore';
import { BUTTON_TYPE, ICON_SIZE } from '../../../global/constants';

interface SnapRecordModalProps {
  handleCloseModal: () => void;
}

const SnapRecordModal: React.FC<SnapRecordModalProps> = ({ handleCloseModal }) => {
  //Other variable
  const { startRecording, audioInputDevices, setSelectedAudioDeviceId, selectedAudioDeviceLabel, updateDevices } =
    useMediaRecorder();

  const requestMicrophonePermission = async () => {
    try {
      const permissionStatus = await navigator.permissions.query({ name: 'microphone' as PermissionName });
      if (permissionStatus.state === 'prompt') {
        await navigator.mediaDevices.getUserMedia({ audio: true });
        updateDevices();
      }
    } catch (error) {
      console.error('Error requesting microphone permission:', error);
    }
  };

  useEffect(() => {
    requestMicrophonePermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnClick = () => {
    startRecording();
    handleCloseModal();
    rootStore.appStore.setScreenRecordingUrl('');
  };

  const renderSelectMicrophone = useMemo(() => {
    const handleMenuClick = (deviceId: string) => {
      setSelectedAudioDeviceId(deviceId);
    };
    return (
      <>
        <DropdownItem label='No Microphone' onClick={() => handleMenuClick('none')} />
        {audioInputDevices.length > 0 &&
          audioInputDevices?.map((device) => (
            <DropdownItem
              key={device.deviceId}
              onClick={() => handleMenuClick(device?.deviceId)}
              label={!isEmpty(device.label) ? device.label : `Microphone ${device.deviceId}`}
            />
          ))}
      </>
    );
  }, [audioInputDevices, setSelectedAudioDeviceId]);

  return (
    <>
      <Header>Select Microphone</Header>
      <Bottom>
        <Dropdown
          activeClassName='active'
          isMinWidth={250}
          content={
            <Top>
              <SVGIcon
                name='microphone-icon'
                width={ICON_SIZE.MD}
                height={ICON_SIZE.MD}
                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                fill=' var(--text-primary)'
              />
              <Text>{selectedAudioDeviceLabel}</Text>
            </Top>
          }
          trigger='click'>
          <>{renderSelectMicrophone}</>
        </Dropdown>

        <ButtonDiv>
          <Button
            title='Start Recording'
            variant={BUTTON_TYPE.PRIMARY}
            className='recording-button'
            onClick={handleOnClick}
          />
        </ButtonDiv>
      </Bottom>
    </>
  );
};
export default SnapRecordModal;
